import { useEffect } from 'react';
import { listenDrivers } from '../../channels/driversChannel';
import { useDriversStore } from '../../stores/useDriversStore';

export function useDriversChannel() {

    useEffect(() => {

        const unsubscribe = listenDrivers(({ tipo, payload }) => {

            const {
                setDrivers,
                upsertDriver,
                removeDriver,
                updateDriversEmViagem,
                setDriversEmViagemSelecionados
            } = useDriversStore.getState();

            if (tipo === 'drivers-sync') {

                setDrivers(payload, false);

            }

            if (tipo === 'driver-upsert') {

                upsertDriver(payload, false);

            }

            if (tipo === 'driver-remove') {

                removeDriver(payload, false);

            }

            if (tipo === 'drivers-trip') {

                updateDriversEmViagem(payload, false);

            }

            if (tipo === 'drivers-trip-selected') {

                setDriversEmViagemSelecionados(payload, false);

            }

        });

        return unsubscribe;

    }, []);

}